import { PostApiAuthGoogleLoginData } from "@nimble/core-client/types";
import { buildErrorMessage } from "@nimble/react-requests/helpers/error-message";
import { useMutation } from "@tanstack/react-query";

import useLastAuthMethod from "@/hooks/auth/use-last-auth-method";
import coreApiClient from "@/lib/api-clients/core-api-client";
import { AUTH_ERROR_MESSAGES } from "@/lib/constants/auth-messages";
import { AUTH_METHODS } from "@/lib/constants/auth-methods";
import { userSchema } from "@/lib/types/auth";

export default function useGoogleSsoAuth() {
  return useMutation({
    mutationFn: async (request: PostApiAuthGoogleLoginData["body"]) => {
      try {
        const { data } = await coreApiClient.postApiAuthGoogleLogin({
          body: request,
        });

        return userSchema.parse(data);
      } catch (error) {
        throw new Error(
          buildErrorMessage(error, AUTH_ERROR_MESSAGES.googleAuthFailed),
        );
      }
    },
    onSuccess: () =>
      useLastAuthMethod.getState().setLastAuthMethod(AUTH_METHODS.GOOGLE),
  });
}
